import axios, { AxiosStatic } from 'axios';
import {
	IApiErrorResponse,
	IError,
	IErrorResponse,
	Locales,
	getUrlRedirectPath,
	removeCartSessionData,
	setRouteLangParam,
} from '@adac-mp/shared';
import { CacheOptions, CacheRequestConfig, setupCache, type AxiosCacheInstance } from 'axios-cache-interceptor';

const cacheOptions: CacheOptions = {
	// Set time to live to 24 hours (in milliseconds)
	ttl: 24 * 60 * 60 * 1000,
	methods: ['get'],
};

export const disableCache: CacheRequestConfig = {
	cache: false,
};

setupCache(axios, cacheOptions);

export const getErrorType = (errorNumber: number) => {
	switch (errorNumber) {
		case 1:
			return '?type=payment';
		case 2:
		case 3:
		case 4:
			return '?type=purchase';
		case 6:
			return '?type=confirmation';
		case 700:
			return '?type=api';
		default:
			return '';
	}
};

// Business logic for UNSUCCESSFUL http calls: response.status should be used, not data.code
export const formatErrorResponse = (response: IErrorResponse) => {
	const {
		status: code,
		data: { errors },
	} = response;

	return { errors, code };
};

export const redirectToErrorPage = (errors?: IError[], lang: Locales | undefined = 'de') => {
	const errorNumber = errors ? errors[0].errorNumber : -1;
	const errorType = getErrorType(errorNumber);
	const domain = getUrlRedirectPath();
	window.location.replace(`${domain}/error${setRouteLangParam(lang)}${errorType}`);
};

export const redirectToSessionExpiredPage = (lang: Locales | undefined, paymentError?: boolean) => {
	removeCartSessionData();
	const domain = getUrlRedirectPath();
	const redirectUrl = `${domain}/session-expired${setRouteLangParam(lang)}${paymentError ? '?type=payment' : ''}`;
	window.location.replace(redirectUrl);
};

export const handleErrorResponse = (
	{ response, paymentError }: IApiErrorResponse,
	lang: Locales | undefined = 'de',
) => {
	const { errors, code } = formatErrorResponse(response);
	if (code === 401) {
		redirectToSessionExpiredPage(lang, paymentError);
	} else {
		redirectToErrorPage(errors, lang);
	}
};

export default axios as AxiosCacheInstance & AxiosStatic;
